import { useEffect, useId, useState } from "react";
import { resendVerification } from "@/lib/api";
import { createErrorMessage } from "@/lib/error-message";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export function ResendVerification({ email: initialEmail = "" }: { email?: string }) {
  const id = useId();
  const [email, setEmail] = useState(initialEmail);
  const [pending, setPending] = useState(false);
  const [cooldown, setCooldown] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!cooldown) return;
    const timer = window.setTimeout(() => setCooldown(false), 60_000);
    return () => window.clearTimeout(timer);
  }, [cooldown]);

  async function resend() {
    setPending(true);
    setMessage("");
    try {
      await resendVerification(email);
      setMessage("인증이 필요한 계정이면 메일을 발송했습니다. 스팸함도 확인해주세요.");
      setCooldown(true);
    } catch (error) {
      setMessage(createErrorMessage(error, "인증 메일을 요청할 수 없습니다."));
    } finally {
      setPending(false);
    }
  }

  return (
    <details className="mt-4 text-sm">
      <summary className="cursor-pointer text-muted-foreground">인증 메일을 받지 못했나요?</summary>
      <div className="mt-3 flex flex-col gap-2">
        <Label htmlFor={id}>가입한 이메일</Label>
        <Input id={id} type="email" autoComplete="email" value={email}
          onChange={(event) => setEmail(event.target.value)} disabled={pending} />
        <Button type="button" variant="outline" disabled={pending || cooldown || !email.trim()}
          onClick={() => void resend()}>
          {pending ? "발송 요청 중…" : cooldown ? "1분 뒤 다시 요청할 수 있습니다" : "인증 메일 다시 받기"}
        </Button>
        <p role="status" className="text-muted-foreground">{message}</p>
      </div>
    </details>
  );
}
